import {push} from 'connected-react-router';
import {get, post, getFiles} from '../utils/api'
import http from '../utils/api'
import {fetchSearchData} from "./searchActions";

export const FETCH_UNIT_BEGIN = 'FETCH_UNIT_BEGIN';
export const FETCH_UNIT_SUCCESS = 'FETCH_UNIT_SUCCESS';
export const FETCH_UNIT_FAILURE = 'FETCH_UNIT_FAILURE';
export const UPDATE_UNIT_BEGIN = 'UPDATE_UNIT_BEGIN';
export const CREATE_UNIT_BEGIN = 'CREATE_UNIT_BEGIN';
export const CREATE_UNIT_SUCCESS = 'CREATE_UNIT_SUCCESS';
export const DELETE_UNIT_BEGIN = 'DELETE_UNIT_BEGIN';
export const DELETE_UNIT_SUCCESS = 'DELETE_UNIT_SUCCESS';
export const DELETE_S3_FILE = 'DELETE_S3_FILE';
export const PUBLISH_TO_JIRA_BEGIN = 'PUBLISH_TO_JIRA_BEGIN';
export const PUBLISH_TO_JIRA_SUCCESS = 'PUBLISH_TO_JIRA_SUCCESS';
export const UPDATE_TO_JIRA_BEGIN = 'UPDATE_TO_JIRA_BEGIN';
export const UPDATE_TO_JIRA_SUCCESS = 'UPDATE_TO_JIRA_SUCCESS';
export const DELETE_FROM_JIRA_BEGIN = 'DELETE_FROM_JIRA_BEGIN';
export const DELETE_FROM_JIRA_SUCCESS = 'DELETE_FROM_JIRA_SUCCESS';
export const DOWNLOAD_FROM_S3 = 'DOWNLOAD_FROM_S3';
export const DOWNLOAD_FROM_S3_BEGINS = 'DOWNLOAD_FROM_S3_BEGINS';
export const ADD_TO_FAVORITES_BEGIN = 'ADD_TO_FAVORITES_BEGIN';
export const ADD_TO_FAVORITES_SUCCESS = 'ADD_TO_FAVORITES_SUCCESS';
export const FETCH_MY_CREATIVES_BEGIN = 'FETCH_MY_CREATIVES_BEGIN';
export const FETCH_MY_CREATIVES_SUCCESS = 'FETCH_MY_CREATIVES_SUCCESS';

export const fetchUnitBegin = () => ({
    type: FETCH_UNIT_BEGIN
});

export const updateUnitBegin = () => ({
    type: UPDATE_UNIT_BEGIN
});

export const createUnitBegin = () => ({
    type: CREATE_UNIT_BEGIN
});

export const createUnitSuccess = () => ({
    type: CREATE_UNIT_SUCCESS
});

export const deleteUnitBegin = () => ({
    type: DELETE_UNIT_BEGIN
});

export const deleteUnitSuccess = () => ({
    type: DELETE_UNIT_SUCCESS
});

export const fetchUnitSuccess = result => ({
    type: FETCH_UNIT_SUCCESS,
    payload: result
});

export const fetchUnitFailure = result => ({
    type: FETCH_UNIT_FAILURE,
    payload: result
});
export const deleteS3File = result => ({
    type: DELETE_S3_FILE,
    payload: result
});
export const publishToJiraBEGIN = () => ({
    type: PUBLISH_TO_JIRA_BEGIN
})
export const publishToJiraSuccess = result => ({
    type: PUBLISH_TO_JIRA_SUCCESS,
    payload: result
})
export const updateToJiraBegin = () => ({
    type: UPDATE_TO_JIRA_BEGIN
})
export const updateToJiraSuccess = result => ({
    type: UPDATE_TO_JIRA_SUCCESS,
    payload: result
})
export const deleteFromJiraBegin = () => ({
    type: DELETE_FROM_JIRA_BEGIN
})
export const deleteFromJiraSuccess = result => ({
    type: DELETE_FROM_JIRA_SUCCESS,
    payload: result
})
export const downloadFromS3Begins = () => ({
    type: DOWNLOAD_FROM_S3_BEGINS
})
export const downloadFromS3Success = result => ({
    type: DOWNLOAD_FROM_S3,
    payload: result
})
export const addToFavoritesBegins = () => ({
    type: ADD_TO_FAVORITES_BEGIN
})
export const addToFavoritesSuccess = result => ({
    type: ADD_TO_FAVORITES_SUCCESS,
    payload: result
})
export const fetchMyCreativesBegin = result => ({
    type: FETCH_MY_CREATIVES_BEGIN,
    payload: result
});
export const fetchMyCreativesSuccess = result => ({
    type: FETCH_MY_CREATIVES_SUCCESS,
    payload: result
});

export function fetchMyCreatives(id, page) {
    return dispatch => {
        dispatch(fetchMyCreativesBegin());
        return get('manage/myCreatives/' + id + '?page=' + page)
            .then((res) => {
                dispatch(fetchMyCreativesSuccess(res));
                return res;
            }, function (res){
                throw res;
            }).catch(err => {
                // dispatch(fetchUnitFailure(err));
            });
    };
}

export function downloadFromS3 (id, name){
    return dispatch => {
        dispatch(downloadFromS3Begins());
        return getFiles('units/download_zip/' + id + '/' + name)
            .then((res) => {
                dispatch(downloadFromS3Success(res));
            }).catch(err => {
                // dispatch(fetchUnitFailure(err));
            });
    };
}
export function fetchUnit(type, id) {
    return dispatch => {
        dispatch(fetchUnitBegin());
        return get('units/' + type + '/' + id)
            .then((res) => {
                dispatch(fetchUnitSuccess(res));
                return res;
            }, function (res){
                throw res;
            }).catch(err => {
                dispatch(fetchUnitFailure(err));
            });
    };
}

export function updateUnit(type, id, data) {
    return dispatch => {
        dispatch(updateUnitBegin());
        return post('units/' + type + '/' + id, data)
            .then((res) => {
                dispatch(fetchUnit(type, id));
            }, function (res) {
                throw res;
            }).catch(err => {
                dispatch(fetchUnitFailure(err));
                throw err.response.data;
            });
    };
}

export function createUnit(type, data) {
    return dispatch => {
        dispatch(createUnitBegin());
        return post('units/' + type, data)
            .then((res) => {
                dispatch(createUnitSuccess());
                return res;
            }, function (res) {
                throw res;
            }).catch(err => {
                dispatch(fetchUnitFailure(err.response.data));
                throw err.response.data;
            });
    };
}


export function deleteUnit(type, id, cid) {
    return dispatch => {
        dispatch(deleteUnitBegin());
        return http.delete('units/' + type + '/' + id)
            .then(res => {
                dispatch(deleteUnitSuccess());
                dispatch(fetchSearchData());
                if (res.data.message === 'success') {
                    dispatch(push('/campaign/' + cid))
                }
            });
    };
}
export function deleteFileS3(type, id, unit, file_type){
    return dispatch => {
        let data = {
            'fileType': file_type
        };
        dispatch(deleteS3File());
        return http.post('units/' + type + '/' + id + '/s3/delete', data)
            .then(res => {
                dispatch(updateUnitBegin());
                dispatch(fetchUnit(type, id));
                return res;
            });
    }
}
export function publishToJira(data){
    return dispatch => {
        dispatch(publishToJiraBEGIN());
        return get('units/jira/' + data.cid + "/" + data.id)
            .then((res) => {
                dispatch(publishToJiraSuccess(res.message));
            });
    }
}
export function updateToJira(data){
    return  dispatch => {
        dispatch(updateToJiraBegin());
        return get('/units/jira/update/' + data.cid + "/" + data.id)
            .then((res) => {
                dispatch(updateToJiraSuccess(res))
            })
    }
}
export function deleteJira(mock_id, jira_id){
    return  dispatch => {
        dispatch(deleteFromJiraBegin());
        return http.post('/units/jira/delete/' + mock_id +"/"+jira_id)
            .then((res) => {
                dispatch(deleteFromJiraSuccess(res.data));
            })
    }
}
export function addToFavorites(data){
    return  dispatch => {
        dispatch(addToFavoritesBegins());
        return http.post('/units/favorite', data)
            .then((res) => {
                dispatch(addToFavoritesSuccess(res.data));
                dispatch(fetchUnit(data.unit_type, data.unit_id));
            })
    }
}
